var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloseModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.255101 0.659544C0.564313 0.324112 1.04818 0.293618 1.38915 0.568062L1.48683 0.659544L9 8.80934L16.5132 0.659544C16.8224 0.324112 17.3062 0.293618 17.6472 0.568062L17.7449 0.659544C18.0541 0.994975 18.0822 1.51987 17.8292 1.88975L17.7449 1.99572L9.61587 10.814C9.30665 11.1495 8.82279 11.18 8.48182 10.9055L8.38413 10.814L0.255101 1.99572C-0.0850335 1.62675 -0.0850335 1.02852 0.255101 0.659544Z",
    fill: "#222222",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7449 19.7234C17.4357 20.0588 16.9518 20.0893 16.6108 19.8149L16.5132 19.7234L9 11.5736L1.48683 19.7234C1.17762 20.0588 0.693754 20.0893 0.352786 19.8149L0.255101 19.7234C-0.0541117 19.388 -0.0822225 18.8631 0.17077 18.4932L0.255101 18.3872L8.38413 9.5689C8.69335 9.23346 9.17721 9.20297 9.51818 9.47741L9.61587 9.5689L17.7449 18.3872C18.085 18.7562 18.085 19.3544 17.7449 19.7234Z",
    fill: "#222222",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseModal);
export default __webpack_public_path__ + "static/media/icon-close-modal.256db0f78fe535ad2c4fd18c4c22b4d2.svg";
export { ForwardRef as ReactComponent };